<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
  <div [innerHTML]="data.htmlPrompt"></div>
</div>
<div mat-dialog-actions>
  <button
    mat-raised-button
    class="piButton"
    (click)="onConfirmClick()"
    cdkFocusInitial
  >
    Confirm
  </button>
</div>
